var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1480,
    height: 676,
    viewBox: "0 0 1480 676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1528.49 406.67L-30.5335 675.943V-58.6876H1528.49V406.67Z",
    fill: "#F6F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundVector);
export default __webpack_public_path__ + "static/media/backgroundVector.f002f9a6d6e66e244f74bc37f08a8330.svg";
export { ForwardRef as ReactComponent };